import { CButton, CForm, CFormLabel, CFormTextarea, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import PatientPhysicalExaminationData from '../../../src/services/general/physicalExaminationData.api'
import PESelectedData from './PESelectedData'
import { RichTextEditorComponent, Inject, HtmlEditor, Toolbar, QuickToolbar, Link, Image } from '@syncfusion/ej2-react-richtexteditor'
import { FilePlus2, Plus } from 'lucide-react'
import HierarchyComponents from './HierarchyComponents'
import { data } from '../../utils/GESelectedData'
import PEHierarchyComponents from './PEHierarchyComponents'
import SaveExtra from '../../services/general/saveExtraData.api'
import ProvidereGeneralExamination from '../../components/shared/ProvidereGeneralExamination'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import Graytextarea from '../../components/Graytextarea'
import Editor, { Toolbar as EditorToolbar } from 'react-simple-wysiwyg'
import { formatPhysicalExaminationHTML } from '../../utils/physicalExaminationFormatter'

const PhysicalExaminationVisualNote = ({ patientID = '-1', isAllotedToProvider = false, saveTreatsShell, noteStructureRef, noteID, showTreatmentAsAccordion = false, disabledTyping = false, setUpdatePE, updatePE }) => {
  const [physicalExaminationData, setPhysicalExaminationData] = useState([])
  const [generalExaminationData, setGeneralExaminationData] = useState([])
  const [diagnosisExaminationData, setDiagnosisExaminationData] = useState([])
  const [visible, setVisible] = useState(false)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [globalRemarkText, setGlobalRemarkText] = useState('')
  const [showGlobalRemarkModal, setShowGlobalRemarkModal] = useState(false)
  const [showEditHtmlModal, setShowEditHtmlModal] = useState(false)
  const [showEditFreetypeModal, setShowEditFreetypeModal] = useState(false)
  const [tempEditHtml, setTempEditHtml] = useState('')
  const [tempEditFreetype, setTempEditFreetype] = useState('')

  const getGeneralExaminationData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'PhysicalExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setGeneralExaminationData(data[0]?.Data)
    } catch (error) {
      console.log('error', error)
      //    toast.error('Failed to fetch data', toastConfig)
    } finally {
    }
  }

  const getDiagnosisExaminationData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'DiagnosisExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setDiagnosisExaminationData(data[0]?.Data)
    } catch (error) {
      console.log('error', error)
      // toast.error('Failed to fetch data', toastConfig)
    } finally {
      console.log('getDiagnosisExaminationData called')
    }
  }

  const [globalRemarkTextToShow, setGlobalRemarkTextToShow] = useState('')

  const fetchData = async () => {
    setIsPageLoading(true)
    let lastGeneralExamination = []
    let lastLastDiagnosisExamination = []
    let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID, noteID)
    const parsedData = JSON.parse(response.d).Data || []
    const findLastDiagnosisExaminationData = parsedData.filter((item) => item.Type === 'DiagnosisExaminationData' && item.NoteID == noteID) || []
    const findLastGeneralDiagnosisExamination = parsedData.filter((item) => item.Type === 'GeneralExaminationData' && item.NoteID == noteID) || []

    const globalRemarks = parsedData.filter((item) => item.Type === 'PhysicalExaminationGlobalRemark' && item?.NoteID === noteID?.toString())

    const lastGlobalRemark = globalRemarks[globalRemarks.length - 1] || null

    const jsonRemarkGlobalRemark = lastGlobalRemark ? JSON.parse(lastGlobalRemark.JsonData) : null

    setGlobalRemarkTextToShow(jsonRemarkGlobalRemark?.globalRemarkText || '')
    setGlobalRemarkText(jsonRemarkGlobalRemark?.globalRemarkText || '')
    // if (findLastGeneralDiagnosisExamination.length > 0) {
    //     lastGeneralExamination = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData) || []
    // setPhysicalExaminationData([...lastLastDiagnosisExamination])
    // }
    // if (findLastDiagnosisExaminationData.length > 0) {
    //     lastLastDiagnosisExamination = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData) || []
    //     setPhysicalExaminationData([...lastGeneralExamination])
    // }
    if (findLastGeneralDiagnosisExamination.length > 0) {
      const parsedGeneral = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData)
      lastGeneralExamination = Array.isArray(parsedGeneral) ? parsedGeneral : []
      setGeneralExaminationData(lastGeneralExamination)
    } else {
      getGeneralExaminationData()
    }
    // Parse and set diagnosis examination data
    if (findLastDiagnosisExaminationData.length > 0) {
      const parsedDiagnosis = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData)
      lastLastDiagnosisExamination = Array.isArray(parsedDiagnosis) ? parsedDiagnosis : []
      setDiagnosisExaminationData(lastLastDiagnosisExamination)
    } else {
      getDiagnosisExaminationData()
    }
    setPhysicalExaminationData([...lastGeneralExamination, ...lastLastDiagnosisExamination])
    setUpdatePE(false)
    setIsPageLoading(false)

    //         setTimeout(() => {
    //   setIsPageLoading(false);
    // }, 3000);
  }
  useEffect(() => {
    fetchData()
  }, [updatePE])
  const [finalHtml, setFinalHtml] = useState('')

  useEffect(() => {
    setFinalHtml(formatPhysicalExaminationHTML(physicalExaminationData))
  }, [physicalExaminationData])

  const handleSave = async () => {
    setIsPageLoading(true)
    const addPE = async (type, data) => {
      try {
        let response = await PatientPhysicalExaminationData('Insert', patientID, noteID, type, JSON.stringify(data))
      } catch (error) {
        toast.error('Failed to save General Examination Data', toastConfig)
        console.error('Error saving General Examination Data:', error)
      } finally {
        setIsPageLoading(false)
      }
    }

    await addPE('GeneralExaminationData', generalExaminationData)
    await addPE('DiagnosisExaminationData', diagnosisExaminationData)
    toast.success('Physical Examination Data saved successfully', toastConfig)
    await fetchData()
    setVisible(false)
    setIsSaving(false)
  }

  const [addingGlobalRemarkLoading, setAddingGlobalRemarkLoading] = useState(false)
  const handleAddGlobalRemarkPE = async () => {
    // const a = await add
    setAddingGlobalRemarkLoading(true)
    let response = await PatientPhysicalExaminationData('Insert', patientID, noteID, 'PhysicalExaminationGlobalRemark', JSON.stringify({ globalRemarkText }))
    setAddingGlobalRemarkLoading(false)
    setShowGlobalRemarkModal(false)
    await fetchData()
  }

  const hasData =
    // globalRemarkTextToShow ||
    (physicalExaminationData?.length > 0 &&
      !physicalExaminationData.every((item) => item.isSelected === false));




  return (
    <div>
      {showTreatmentAsAccordion ? (
        <div>
          <div className=" ">
            <div className="patient-note-section-header d-flex align-items-center gap-2">
              <div className="patient-note-section-title" style={{ fontSize: '16px' }}>
                {' '}
                Physical Examination
              </div>
            </div>

            {isPageLoading ? (
              <div>
                <CSpinner size="sm" className="me-2" />
                Loading...
              </div>
            ) : (
              <div className=" PhysicalExaminationVisualNote">
                {finalHtml && (
                  <RichTextEditorComponent
                    value={finalHtml}
                    style={{
                      border: 0,
                    }}
                    readOnly={true}
                    enabled={true}
                    toolbarSettings={{ enable: false }}
                    height={physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}
                  >
                    <Inject services={[Toolbar, HtmlEditor]} />
                  </RichTextEditorComponent>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <div className="card mb-4 p-3">
            <CAccordion className="border-0" flush>
              <CAccordionItem itemKey={1}>
                <CAccordionHeader>
            <div className="patient-note-section-header d-flex align-items-center gap-2">
              <h6 className="patient-note-section-title fs-7 mb-0 p" style={{ opacity: '0.8' }}>
                Physical Examination
              </h6>
              {isAllotedToProvider && (
                <CFormLabel
                  className="patient-note-action d-flex mt flex-column align-items-center justify-content-center shadow"
                  onClick={(e) => { e.stopPropagation(); setVisible((p) => !p) }}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: 'var(--ui-color-primary, #2b7cd3)',
                    cursor: 'pointer',
                  }}
                >
                  <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
                </CFormLabel>
              )}
              <CFormLabel
                className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
                onClick={(e) => { e.stopPropagation(); setShowGlobalRemarkModal((p) => !p) }}
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '20px',
                  background: 'var(--ui-color-primary, #2b7cd3)',
                  cursor: 'pointer',
                }}
              >
                <FilePlus2 className="patient-note-action-icon" strokeWidth={2} size={15} />
              </CFormLabel>
            </div>
                </CAccordionHeader>
                <CAccordionBody>
            {/* {noteStructureRef?.current?.freeTypesEverything?.peChanges?.html && (
              <>
                <hr />

                <div className="mt-2" style={{ background: '#f6f6f6ff', borderRadius: '10px' }}>
                  {noteStructureRef?.current?.freeTypesEverything?.peChanges?.html && (
                    <div
                      className="p-4"
                      onClick={() => {
                        setShowEditHtmlModal(true)
                        setTempEditHtml(noteStructureRef?.current?.freeTypesEverything?.peChanges?.html || '')
                      }}
                      dangerouslySetInnerHTML={{
                        __html: noteStructureRef?.current?.freeTypesEverything?.peChanges?.html,
                      }}
                    />
                  )}
                </div>
                <hr />
              </>
            )} */}



             {noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText && (
              <>
                <div className="mt-2">
                  <div
                    className="p-4"
                    style={{
                      background: 'inherit',
                      borderRadius: '10px',
                      border: '1px solid gray',
                      color: 'inherit',
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                      opacity: 0.8,
                      // userSelect: 'none' // optional
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText,
                    }}
                  />
                </div>
                <hr />
              </>
            )}
            {noteStructureRef?.current?.freeTypesEverything?.peChanges?.html && (
              <>
           

                <div className="mt-2">
                  <div
                    className="p-4"
                    style={{
                      background: 'inherit',
                      borderRadius: '10px',
                      border: '1px solid gray',
                      color: 'inherit',
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                      opacity: 0.8,
                      // userSelect: 'none' // optional
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        noteStructureRef?.current?.freeTypesEverything?.peChanges?.html,
                    }}
                  />
                </div>

                <hr />
              </>
            )}

            {/* {noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText && (
              <>
                <div className="mt-2" style={{ background: '#f6f6f6ff', borderRadius: '10px' }}>
                  {noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText && (
                    <div
                      className="p-4"
                      onClick={() => {
                        setTempEditFreetype(noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText || '')
                        setShowEditFreetypeModal(true)
                      }}
                      dangerouslySetInnerHTML={{
                        __html: noteStructureRef?.current?.freeTypesEverything?.peChanges?.globalRemarkText,
                      }}
                    />
                  )}
                </div>
                <hr />
              </>
            )} */}
            

            {/* <CForm>
                     <CFormTextarea
                         className="bg-secondary border rounded shadow-sm mt-2"
                         rows={3}
                     />
                 </CForm> */}
            {isPageLoading ? (
              <div>
                <CSpinner size="sm" className="me-2" />
                Loading...
              </div>
            ) : (



              //          <div>
              //   <Graytextarea value={globalRemarkTextToShow} height={'20px'} />
              //   <div className="mt-2 PhysicalExaminationVisualNote">
              //     <RichTextEditorComponent
              //       value={globalRemarkTextToShow ? finalHtml || '' : finalHtml ? finalHtml : 'No Physical Examination found'}
              //       // value={finalHtml ? finalHtml : 'No Physical Examination found'}
              //       readonly
              //       style={{
              //         border: 0,
              //       }}
              //       readOnly={true}
              //       enabled={true}
              //       toolbarSettings={{ enable: false }}
              //       height={globalRemarkTextToShow ? 0 : physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}

              //       // height={physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}
              //     >
              //       <Inject services={[Toolbar, HtmlEditor]} />
              //     </RichTextEditorComponent>
              //   </div>
              // </div>






              // <div >
              //   <CFormTextarea value={globalRemarkTextToShow} height={'20px'} style={{border: "1px solid lightGray", borderRadius: "5px", backgroundColor: "#f7f7f8"}} />


              //     <div className="mt-2 PhysicalExaminationVisualNote" >
              //     <RichTextEditorComponent
              //       value={globalRemarkTextToShow ? finalHtml || '' : finalHtml ? finalHtml : 'No Physical Examination found'}
              //       // value={finalHtml ? finalHtml : 'No Physical Examination found'}
              //       readonly
              //       style={{
              //         border: 0,
              //       }}


              //       readOnly={true}
              //       enabled={true}
              //       toolbarSettings={{ enable: false }}
              //       height={globalRemarkTextToShow ? 0 : physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}

              //       // height={physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}
              //     >
              //       <Inject services={[Toolbar, HtmlEditor]} />
              //     </RichTextEditorComponent>
              //   </div>




              //   {hasData ? (          <div className="mt-2 PhysicalExaminationVisualNote" >
              //     <RichTextEditorComponent
              //       value={globalRemarkTextToShow ? finalHtml || '' : finalHtml ? finalHtml : 'No Physical Examination found'}
              //       // value={finalHtml ? finalHtml : 'No Physical Examination found'}
              //       readonly
              //       style={{
              //         border: 0,
              //       }}


              //       readOnly={true}
              //       enabled={true}
              //       toolbarSettings={{ enable: false }}
              //       height={globalRemarkTextToShow ? 0 : physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}

              //       // height={physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}
              //     >
              //       <Inject services={[Toolbar, HtmlEditor]} />
              //     </RichTextEditorComponent>
              //   </div>):( null)} 
              // </div>

              <div >
                <CFormTextarea value={globalRemarkTextToShow} height="20px" style={{ backgroundColor: "#f7f7f8", borderRadius: "5px", border: "1px solid lightGray", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }} />

                {hasData ? (
                  <div className="mt-2 PhysicalExaminationVisualNote">


                    <RichTextEditorComponent
                      value={globalRemarkTextToShow ? finalHtml || '' : finalHtml || ''}

                      readonly
                      toolbarSettings={{ enable: false }}
                      style={{ border: 0, }}
                      height="auto"

                    >
                      <Inject services={[Toolbar, HtmlEditor]} />
                    </RichTextEditorComponent>
                  </div>
                ) : null}
              </div>
            )}
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>
          </div>
        </div>
      )}
      <CModal size="xl" backdrop="static" visible={visible} onClose={() => setVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        {/* <CModalHeader>
          <CModalTitle id="StaticBackdropExampleLabel">Modal title</CModalTitle>
        </CModalHeader> */}
        <CModalBody
          style={{
            height: '650px',
            overflowY: 'auto',
            padding: '24px',
            backgroundColor: '#f8f9fa', // subtle background for better contrast
          }}
        >
          <CAccordion alwaysOpen activeItemKey={1}>
            {/* General Examination Section */}
            <CAccordionItem itemKey={1} className="mb-3 border-0 shadow-sm rounded">
              <CAccordionHeader className="patient-note-section-title bg-light fw-bold">General Examination</CAccordionHeader>
              <CAccordionBody className="bg-white p-4 rounded-bottom">
                {generalExaminationData.length > 0 ? (
                  <ProvidereGeneralExamination generalExaminationData={generalExaminationData} setGeneralExaminationData={setGeneralExaminationData} />
                ) : (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <CSpinner color="primary" />
                  </div>
                )}
              </CAccordionBody>
            </CAccordionItem>

            {/* Diagnosis Section */}
            <CAccordionItem itemKey={2} className="mb-3 border-0 shadow-sm rounded">
              <CAccordionHeader className="patient-note-section-title bg-light fw-bold">Diagnosis</CAccordionHeader>
              <CAccordionBody className="bg-white p-4 rounded-bottom">
                {diagnosisExaminationData.length > 0 ? (
                  <ProvidereGeneralExamination generalExaminationData={diagnosisExaminationData} setGeneralExaminationData={setDiagnosisExaminationData} />
                ) : (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <CSpinner color="primary" />
                  </div>
                )}
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>
        </CModalBody>

        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              ; (handleSave(), setIsSaving(true))
            }}
          >
            {isSaving ? (
              <>
                <CSpinner size="sm" className="me-2" />
                Saving...
              </>
            ) : (
              'Save'
            )}
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal backdrop="static" visible={showGlobalRemarkModal} onClose={() => setShowGlobalRemarkModal(false)} aria-labelledby="StaticBackdropExampleLabel">
        <CModalHeader>
          <CModalTitle id="StaticBackdropExampleLabel">Add Global Remark</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Graytextarea placeholder="Enter freetype" value={globalRemarkText} rows={4} onChange={(e) => setGlobalRemarkText(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton variant='outline' color="secondary" onClick={() => setShowGlobalRemarkModal(false)}>
            Cancel
          </CButton>
           <CButton
            style={{
              minWidth: '90px',
              backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
              borderColor: 'var(--ui-color-primary, #2b7cd3)',
            }}
            onClick={async () => {
              await handleAddGlobalRemarkPE()
            }}
            color="primary"
            aria-label={addingGlobalRemarkLoading ? 'Saving global remark' : 'Save global remark'}
          >
            {addingGlobalRemarkLoading ? <CSpinner component="span" size="sm" color="light" aria-hidden="true" /> : 'Save'}
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal size="lg" visible={showEditHtmlModal} onClose={() => setShowEditHtmlModal(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Physical Examination Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempEditHtml(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempEditHtml}
          >
            <EditorToolbar />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtmlModal(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current.freeTypesEverything,
                  peChanges: {
                    ...noteStructureRef.current.freeTypesEverything?.peChanges,
                    html: tempEditHtml,
                  },
                },
              }
              // saveTreatsShell();
              setShowEditHtmlModal(false)
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showEditFreetypeModal} onClose={() => setShowEditFreetypeModal(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Physical Examination Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempEditFreetype(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempEditFreetype}
          >
            <EditorToolbar />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditFreetypeModal(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current.freeTypesEverything,
                  peChanges: {
                    ...noteStructureRef.current.freeTypesEverything?.peChanges,
                    globalRemarkText: tempEditFreetype,
                  },
                },
              }
              saveTreatsShell(false)
              setShowEditFreetypeModal(false)
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default PhysicalExaminationVisualNote
